import React from 'react';
import { FadeIn } from './Shared';
import { AlertTriangle, XCircle, ZapOff, Activity, Cigarette } from 'lucide-react';
export function Problem() {
  const failures = [{
    icon: <ZapOff className="text-red-500" size={24} data-id="element-129" />,
    title: 'Cold Turkey Fails',
    desc: 'Because Nic-Salts cause a massive dopamine crash that willpower alone cannot fix.'
  }, {
    icon: <Activity className="text-red-500" size={24} data-id="element-130" />,
    title: "Nicotine Patches Don't Cut It",
    desc: "They provide a steady stream, but don't solve the 'Hand-to-Mouth' physical twitch you've developed over thousands of puffs."
  }, {
    icon: <AlertTriangle className="text-red-500" size={24} data-id="element-131" />,
    title: "The 'Just One Hit' Lie",
    desc: 'Once those receptors are primed at the pub, you reset the 72-hour addiction clock instantly.'
  }, {
    icon: <Cigarette className="text-red-500" size={24} data-id="element-132" />,
    title: "Switching to 'Lights'",
    desc: 'Only adds tar and carbon monoxide to a problem that is already chemical.'
  }];
  return <section className="py-24 px-4 bg-neutral-950 relative border-t border-neutral-900" data-id="element-133">
      <div className="max-w-5xl mx-auto" data-id="element-134">
        <FadeIn data-id="element-135">
          <div className="grid md:grid-cols-2 gap-12 items-center mb-24" data-id="element-136">
            <div data-id="element-137">
              <h2 className="text-4xl md:text-5xl font-black uppercase mb-6" data-id="element-138">
                The <span className="text-toxic" data-id="element-139">7-Second</span> Trap
              </h2>
              <div className="space-y-6 text-lg text-neutral-400" data-id="element-140">
                <p data-id="element-141">
                  If you're in Australia, you've likely been buying
                  "under-the-counter" 5% (50mg) disposables.
                  <strong className="text-white block mt-2" data-id="element-142">
                    These aren't like cigarettes.
                  </strong>
                </p>
                <p data-id="element-143">
                  They are megadoses of Nicotine Salts designed to cross the
                  blood-brain barrier in{' '}
                  <span className="text-toxic font-bold" data-id="element-144">7 seconds</span>.
                </p>
                <p data-id="element-145">
                  That's why the patch doesn't work. That's why gum feels like a
                  joke. Your brain is addicted to the "Spike," not a slow
                  release. When you try to quit cold turkey, the irritability
                  becomes so violent that you're back at the convenience store
                  within six hours, feeling like a failure.
                </p>
              </div>
            </div>

            <div className="relative" data-id="element-146">
              <div className="absolute inset-0 bg-toxic/20 blur-[100px] rounded-full" data-id="element-147" />
              <div className="bg-neutral-900 border border-neutral-800 p-8 relative z-10" data-id="element-148">
                <div className="text-6xl font-black text-transparent bg-clip-text bg-gradient-to-b from-white to-neutral-600 mb-4" data-id="element-149">
                  50mg
                </div>
                <div className="text-xl font-display font-bold text-white mb-2" data-id="element-150">
                  The Disposable Megadose
                </div>
                <div className="w-full bg-neutral-800 h-2 mt-4 overflow-hidden" data-id="element-151">
                  <div className="bg-toxic h-full w-full animate-pulse" data-id="element-152" />
                </div>
                <div className="text-sm text-neutral-500 mt-2 text-right" data-id="element-153">
                  Blood-brain barrier: 7s
                </div>
              </div>
            </div>
          </div>
        </FadeIn>

        <FadeIn data-id="element-154">
          <div className="text-center mb-12" data-id="element-155">
            <h3 className="text-3xl font-black uppercase" data-id="element-156">
              Why What You Tried Didn't Work
            </h3>
            <div className="w-24 h-1 bg-red-500 mx-auto mt-6" data-id="element-157" />
          </div>

          <div className="grid sm:grid-cols-2 gap-6" data-id="element-158">
            {failures.map((item, i) => <FadeIn key={i} delay={i * 0.1} data-id="element-159">
                <div className="bg-neutral-900/50 border border-neutral-800/50 p-6 flex gap-4 hover:border-red-500/30 transition-colors" data-id="element-160">
                  <div className="shrink-0 mt-1" data-id="element-161">{item.icon}</div>
                  <div data-id="element-162">
                    <h4 className="font-display font-bold text-white text-lg mb-2" data-id="element-163">
                      {item.title}
                    </h4>
                    <p className="text-neutral-400 leading-relaxed" data-id="element-164">
                      {item.desc}
                    </p>
                  </div>
                </div>
              </FadeIn>)}
          </div>
        </FadeIn>
      </div>
    </section>;
}